import React from "react";
export const HOME = {
  emergentLink: "emergent-link",
};
export const APP = {
  searchInput: "plant-search-input",
  categoryFilter: "category-filter",
  severityFilter: "severity-filter",
  plantCard: "plant-card",
  plantDetailModal: "plant-detail-modal",
  simulatorSelect: "simulator-item-checkbox",
  simulatorRunBtn: "simulator-run-btn",
  emergencyBtn: "emergency-sos-btn",
  dietTab: "diet-planner-tab",
  reportsTab: "community-reports-tab",
};
